import { Injectable } from '@angular/core';
import { CategoryTag } from '@catalog/const';
import { select, Store } from '@ngrx/store';
import { encodeUid } from '@shared/helpers';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CatalogActions } from '../store/actions';
import { StateWithCatalog } from '../store/catalog-state';
import { CatalogSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CategoryTagsFacade {
  constructor(private store: Store<StateWithCatalog>) {}

  loadCategoryTags(uid: string): void {
    this.store.dispatch(new CatalogActions.LoadCategoryTags(uid));
  }

  getCategoryTags(citySlug: string, categoryCode: string): Observable<CategoryTag[]> {
    const uid = encodeUid(citySlug, categoryCode);

    return this.store.pipe(
      select(CatalogSelectors.getCategoryTags(uid)),
      tap((loaderState: StateUtils.LoaderState<CategoryTag[]>) => {
        const isNotLoaded = !loaderState.loading && !loaderState.success && !loaderState.error;

        if (isNotLoaded) {
          this.loadCategoryTags(uid);
        }
      }),
      map((loaderState: StateUtils.LoaderState<CategoryTag[]>) => loaderState.value),
    );
  }

  getActiveCategoryTagItem(): Observable<CategoryTag | undefined> {
    return this.store.pipe(select(CatalogSelectors.getActiveCategoryTagValue()));
  }

  getCategoryTagsLoading(citySlug: string, categoryCode: string): Observable<boolean> {
    const uid = encodeUid(citySlug, categoryCode);

    return this.store.pipe(select(CatalogSelectors.getCategoryTagsLoading(uid)));
  }
}
